import {WeekDay} from "@angular/common";

export class OpeningTimeDetailRes {
  day!: number;
  from!: number;
  to!: number;

  constructor(d?: number, f?: number, t?: number) {
    this.day = d!;
    this.from = f!
    this.to = t!
  }
}

export class OpeningTimeCreateReq {
  day!: WeekDay;
  from!: number;
  to!: number;
  constructor(opening?: OpeningTimeDetailRes) {
    if (opening == undefined) {
      this.day = (new Date(Date.now()).getDay())
      this.from = 8;
      this.to = this.from + 8
      return
    }
    this.to = opening.to;
    this.from = opening.from;
    this.day = opening.day
  }
}
